export default __webpack_public_path__ + "static/media/ticket18.c49695dd.jpg";